import './_submenu-links-and-image-block.scss';
import component from './submenu-links-and-image-block';

export default component;
